/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import validate from 'validate.js';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import { Input, DialogDefault, NumberInput, OptionSelect } from '../../../components';
import { v4 as uuidv4 } from 'uuid';
import { buildRequiredSchema } from 'utils';

const useStyles = makeStyles(() => ({
  gridContainer: {
    marginTop: 0
  },
  fieldContainer: {
    paddingBottom: '0px !important'
  }
}));

const defaultValue = {
  'tipoCompraNota': 'PECAS_MANUTENCAO_VEICULAR'
};


const PecasFormulario = ({ open, onClose, onSave, selectedPeca }) => {
  const classes = useStyles();

  const [values, setValues] = useState(defaultValue);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (selectedPeca) {
      setValues(selectedPeca);
    } else {
      setValues(defaultValue);
    }
  }, [selectedPeca]);

  const onCloseLocal = () => {
    setErrors({});
    setValues(defaultValue);
    onClose();
  };

  const handleChange = event => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const onSaveLocal = () => {
    const erros = validate(values, buildRequiredSchema(['tipoCompraOptionId', 'valor', 'quantidade']));
    setErrors(erros || {});
    if (!erros) {
      let data = values;
      if (!data.id) {
        data = { ...data, id: uuidv4() };
      }
      onSave(data);
      setValues(defaultValue);
    }
  };

  return (
    <DialogDefault
      open={open}
      handlerCancel={onCloseLocal}
      handlerConfirm={onSaveLocal}
      title="Peça"
      confirmMessage={selectedPeca ? 'Atualizar' : 'Adicionar'}
      maxWidth="md"
    >
      <Grid container spacing={3} className={classes.gridContainer}>
        <Grid item xs={6} className={classes.fieldContainer}>
          <OptionSelect
            label="Peça"
            codigo="NOTA_COMPRAS_PECAS"
            isRequired
            onSelect={(tipoCompraOptionId, tipoCompraOptionNome) => setValues({ ...values, tipoCompraOptionId, tipoCompraOptionNome })}
            value={values.tipoCompraOptionId}
            error={errors && errors.tipoCompraOptionId ? true : false}
          />
        </Grid>
        <Grid item xs={3} className={classes.fieldContainer}>
          <NumberInput
            error={errors && errors.valor ? true : false}
            isRequired
            label="Valor"
            prefix="R$ "
            onChange={valor => setValues({ ...values, valor })}
            value={values.valor}
            decimalScale={2}
          />
        </Grid>
        <Grid item xs={3} className={classes.fieldContainer}>
          <Input
            label="Quantidade"
            name="quantidade"
            onChange={handleChange}
            value={values.quantidade}
            error={errors && errors.quantidade ? true : false}
            isRequired
          />
        </Grid>
        <Grid item xs={12} className={classes.fieldContainer}>
          <Input
            label="Descrição"
            name="descricao"
            onChange={handleChange}
            value={values.descricao}
            rows={2}
            multiline
          />
        </Grid>
      </Grid>
    </DialogDefault>
  );
};

export default PecasFormulario;
